<template>
  <div>
    <div class="result-page" v-show="isLoaded">
      <div class="result-body col-center">
        <md-icon :name="icon" class="icon"></md-icon>
        <p class="text row-center">{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Toast, Dialog } from 'mand-mobile';
import postOrderResult from '@/api/post-order-result';
import { getMixinAuth } from '@/api/user';
export default {
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {
      isLoaded: false,
      icon: '',
      msg: '',
    };
  },
  mounted() {
    const query = this.$route.query;
    const id = query.id;
    const action = query.action;
    this.isLoaded = false;
    if (!id || !action) {
      this.icon = 'warn-color';
      this.msg = this.$t('error.para');
      this.isLoaded = true;
      return;
    }
    new Promise((resolve, reject) => {
      let obj;
      if (action == 'cancel_paid' || action == 'cancel') {
        obj = {
          icon: 'warn',
          title: this.$t('result.cancelContent'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('result.cancelTransaction'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (action == 'not_received') {
        obj = {
          icon: 'warn',
          title: this.$t('result.notReceivedContent'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('common.confirm'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (action == 'pay_assets') {
        obj = {
          icon: 'warn',
          title: this.$t('result.transferAlert'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('common.confirm'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (obj) {
        Dialog.confirm(obj);
      } else {
        resolve();
      }
    })
      .then(() => {
        Toast.loading(this.$t('common.loading'));
        postOrderResult(id, action)
          .then(data => {
            Toast.hide();
            this.icon = 'success-color';
            this.msg = data.message;
            this.isLoaded = true;
            const codeId = data.data.code_id;
            if (codeId) {
              window.location.replace(`https://mixin.one/codes/${codeId}`);
            }
          })
          .catch(err => {
            Toast.hide();
            if (err.code == '1075') {
              return Dialog.confirm({
                icon: '',
                title: err.message,
                cancelText: this.$t('common.cancel'),
                confirmText: this.$t('common.reauthorize'),
                onConfirm: () => {
                  getMixinAuth()
                    .then(data => {
                      return window.location.replace(data.data.url);
                    })
                    .catch(err => {
                      Toast.failed(err.message);
                    });
                },
              });
            }
            this.isLoaded = true;
            this.icon = 'wrong';
            this.msg = err.message || this.$t('error.unknown');
          });
      })
      .catch(() => {});
  },
};
</script>

<style lang="stylus" scoped>
.result-page {
  .result-body {
    padding-top: 32vw;
    width: 100%;
  }

  .icon {
    font-size: 30vw;
    icon-size(30vw);
  }

  .text {
    margin: 9.6vw 9.6vw 0;
    font-size: 6.4vw;
  }
}
</style>
